import { Flex } from "@mantine/core";

import NavbarUtilityBar from "@/components/Navbar/NavbarUtilityBar";

const LayoutFooter = () => {
  return (
    <Flex
      align="center"
      justify="center"
      wrap="wrap"
      gap="xs"
      px="xl"
      py="md"
      style={{ boxShadow: "var(--mantine-shadow-sm-inverted)" }}
    >
      <NavbarUtilityBar />
    </Flex>
  );
};

export default LayoutFooter;
